<template>
<div class="wrapper">
  <h5 class="mt-3">Letzte Nachrichten</h5>
  <div class="btn-toolbar mt-3">
    <div class="btn-group">
      <button @click="prevPage" class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
      <button @click="nextPage" class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
    </div>
  </div>
  <b-table class="mt-3" hover :items="messages" :fields="fields" :tbody-tr-class="rowClass">
    <template v-slot:cell(type)="data">
      <font-awesome-icon v-if="data.item.type==0" icon="arrow-right"/>
      <font-awesome-icon v-else icon="arrow-left"/>
    </template>
  </b-table>
</div>
</template>

<script>
import chatbot from '@/modules/chatbot.js'

export default {
  name: 'ChatBotMsgHistory',
  data() {
    return {
      start: 0,
      count: 20,
      messages: [],
      fields: [
        { label: 'ID', key: 'id'},
        { label: 'Teilnehmer', key: 'from'},
        { label: 'Richtung', key: 'type'},
        { label: 'Nachricht', key: 'text'},
        { label: 'Datum', key: 'send'},
        { label: 'Prozess', key: 'procid'},
      ],
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    rowClass(item, type) {
      console.log(item.type);
      if (!item || type !== 'row') return
      if (item.type === 0)
        return 'sendmsg'
      else {
        return 'recvmsg'
      }
    },
    fetchData: function() {
      var self = this;
      chatbot.messages(this,this.start,this.count,function(data) {
        self.messages = data;
      })
    },
    nextPage() {
      this.start += this.count;
      this.fetchData();
    },
    prevPage() {
      if (this.start > 0) {
        this.start -= this.count;
        this.fetchData();
      }
    }
  }
}
</script>

<style>
.sendmsg {
  background-color: #eef;
}
.recvmsg {
  background-color: #ded;
}
</style>
